import(/* webpackMode: "eager" */ "/app/node_modules/@cosmos/web-react/dist/esm/components.js");
;
import(/* webpackMode: "eager" */ "/app/src/assets/css/main.css");
;
import(/* webpackMode: "eager" */ "/app/src/components/ErrorStatement/ErrorStatement.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/app/src/components/Header/Header.tsx");
